import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { compose } from 'redux';
import { Link } from 'react-router-dom';
import { firestoreConnect } from 'react-redux-firebase';
import M from 'materialize-css';

function AllContest(props) {
  const { contests } = props;
  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const renderClickableId = (contest) =>
    contest.id ? (
      <p className="company-address">
        {`ID: `}
        <button className="id-link" onClick={() => copyIdToClipboard(contest.id)}>
          {contest.id}
        </button>
        {contest.active && <span className="new badge" data-badge-caption="ACTIVE"></span>}
        <br/>
        {contest.type}
      </p>
    ) : null;

  const copyIdToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    M.toast({ html: 'ID copied' });
  };

  return (
    <div className="dashboard container">
      <div className="title-section">All Contests</div>
      <div className="row">
        {contests ? (
          contests.map((contest) => {
            return (
              <div key={contest.id} className="col s12 m6">
                <div className="card z-depth-0">
                  <div className="card-content grey-text text-darken-3">
                    <h5>{contest.name} ({contest.countryCode})</h5>
                    {renderClickableId(contest)}
                  </div>
                  <div className="card-action">
                    <Link
                      className="btn-flat"
                      to={{
                        pathname: '/newContest',
                        contest: contest,
                        edit: true,
                      }}>
                      Edit
                    </Link>
                    <Link
                      className="btn-flat"
                      to={{
                        pathname: '/newContest',
                        contest: contest,
                        edit: false,
                      }}>
                      Clone
                    </Link>
                    <Link to="#">Delete</Link>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div />
        )}
      </div>
      <Link className="btn-floating btn-large fixed-action-btn green right" to="newContest">
        <i className="material-icons">add</i>
      </Link>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    contests: state.firestore.ordered.contests,
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect([{ collection: 'contests', orderBy: ['name', 'asc'] }]), connect(mapStateToProps))(AllContest);
